import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { tourSteps } from "./tourStepData";
import { TooltipPosition, TourState, TourStep } from "./tourTypes";

const initialState: TourState = {
  steps: tourSteps,
  isTourActive: false,
  showInitialPopup: true, // First-time users see the popup
  currentStepIndex: 0,
  tooltipPosition: { top: 0, left: 0 },
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    startTour: (state) => {
      state.showInitialPopup = false;
      state.isTourActive = true;
      state.currentStepIndex = 0;
    },
    skipTour: (state) => {
      state.showInitialPopup = false;
      state.isTourActive = false;
    },
    nextStep: (state) => {
      if (state.currentStepIndex < state.steps.length - 1) {
        state.currentStepIndex += 1;
      } else {
        state.isTourActive = false;
      }
    },
    endTour: (state) => {
      state.isTourActive = false;
    },
    setTooltipPosition: (state, action: PayloadAction<TooltipPosition>) => {
      state.tooltipPosition = action.payload;
    },
    hideInitialPopup: (state) => {
      state.showInitialPopup = false;
    },
  },
});

export const {
  startTour,
  skipTour,
  nextStep,
  endTour,
  setTooltipPosition,
  hideInitialPopup,
} = tourSlice.actions;

// Selectors
export const selectIsTourActive = (state: RootState): boolean =>
  state.tour.isTourActive;
export const selectShowInitialPopup = (state: RootState): boolean =>
  state.tour.showInitialPopup;
export const selectCurrentStepIndex = (state: RootState): number =>
  state.tour.currentStepIndex;
export const selectCurrentStep = (state: RootState): TourStep | undefined =>
  state.tour.steps[state.tour.currentStepIndex];
export const selectTotalSteps = (state: RootState): number =>
  state.tour.steps.length;
export const selectTooltipPosition = (state: RootState): TooltipPosition =>
  state.tour.tooltipPosition;

export default tourSlice.reducer;
